import Vue from "vue";
import { newRoutes } from "../../main"

const state = {
    userData: {
        NUserCode: 0,             // کد کاربری
        NPerNationalId: '',       // کد ملی
        SUserName: '',            // نام کاربری
        SMobileNo: '',            // تلفن همراه
        SImageName: '',           // تصویر کاربر
        SImageUserBase64: '',     // دیتای تصویر کاربر
        NState: 1,                // وضعیت فعالیت
        token: '',                // توکن
        expireTime: 3,            // تاریخ انقضاء توکن
        Accept: false,            // وضعیت کنترل ورود دو مرحله ای
        ShowAlertAdmin: false     // وضعیت مشاهده هشدارهای مدیر
    },
    LoginError: '',
    CaptchaHash: '',
    LoginLevel: 1,                // بررسی مرحله لاگین : 1 نام کاربر و رمز - 2 رمز یکبار مصرف
    LoginNationalID: '',          // کد ملی کاربر در حال لاگین
    CaptchaIsRequired: false,     // ثبت کپچا الزامی است جهت فرم رمز یکبار مصرف
}

const getters = {
    // دریافت اطلاعات کاربر
    getUserData(state) {
        return state.userData;
    },
    // دریافت متن خطا
    getLoginError(state) {
        return state.LoginError;
    },
    getCaptchaHash(state) {
        return state.CaptchaHash;
    },
    // دریافت مرحله ورود
    getLoginLevel(state) {
        // 1: نام کاربری ، رمز ورود و کپچا
        // 2: رمز یکبار مصرف پیامک شده
        return state.LoginLevel;
    },
    // دریافت کد ملی کاربر در حال لاگین
    getLoginNationalID(state) {
        return state.LoginNationalID;
    },
    // دریافت وضعیت ثبت کپچا الزامی است
    getCaptchaIsRequired(state) {
        return state.CaptchaIsRequired;
    }
}

const mutations = {

    setUserData(state, user) {
        state.userData = user;
    },
    setLoginError(state, errorText) {
        state.LoginError = errorText;
    },
    setCaptchaHash(state, captchahash) {
        state.CaptchaHash = captchahash;
    },
    setLoginLevel(state, loginLevel) {
        state.LoginLevel = loginLevel;
    },
    // تنظیم کد ملی کاربر در حال لاگین
    setLoginNationalID(state, nationalID) {
        state.LoginNationalID = nationalID;
    },
    // تنظیم وضعیت ثبت کپچا الزامی است
    setCaptchaIsRequired(state, required) {
        state.CaptchaIsRequired = required;
    }
}

const actions = {
    // تابع لاگین کاربر - احراز هویت مرحله یک
    async LoginPart1_SendAcceptCode({ commit, dispatch, state }, user) {
        commit('setLoginError', '');
        await commit('setLoginLevel', 1);
        await Vue.http.post('Login/LoginPart1_SendAcceptCode', user).then(async response => {
            // console.log(response);
            if (response.body.result === 'OK') {
                // آیا ورود دو مرحله ای فعال است ؟
                if (response.body.SMS_Authentication_Active == true) {
                    // کد یکبار مصرفی پیامکی ارسال شده است
                    await commit('setLoginLevel', 2);
                    // ذخیره کد ملی کاربر در حال لاگین
                    await commit('setLoginNationalID', user.NationalID);
                    newRoutes.push("CheckAcceptCode");
                } else {
                    // ورود دو مرحله ای غیرفعال است
                    // ورود بدون ارسال پیامک کد یکبار مصرف

                    // ذخیره کد ملی کاربر در حال لاگین
                    await commit('setLoginNationalID', user.NationalID);
                    await commit('setLoginLevel', 2);
                    await commit('setUserData', response.body.result_value);
                    await dispatch('setAuthCookie', response);
                    newRoutes.push("AdminPanel");
                }
            } else {
                await commit('setLoginError', response.body.text);
                if (response.body.blockStatus == true) {
                    newRoutes.push("BlockIP");
                }
            };
        }, async error => {
            // await commit('setLoginError', 'در اتصال به سرور خطایی رخ داده است !');
            await commit('setLoginError', error.body.text);
            dispatch('notify', {
                // notText: 'بروز خطای ناشناخته !!\nلطفا علت بروز خطا را بررسی نمایید .',
                notText: error.body.text,
                timeOut: 2500,
            });
            if (error.body.blockStatus == true) {
                newRoutes.push("BlockIP");
            }
            console.log('response error ...', error);
        }).catch(async err => {
            await commit('setLoginError', 'در اتصال به سرور خطایی رخ داده است !');
            dispatch('notify', {
                notText: 'بروز خطای ناشناخته !!\nلطفا علت بروز خطا را بررسی نمایید .',
                timeOut: 2500,
            });
            console.log('catch error ...', err);
        });
    },

    // تابع لاگین کاربر - احراز هویت مرحله دو
    async LoginPart2_CheckAcceptCode({ commit, dispatch, state }, checkAcceptCode) {
        commit('setLoginError', '');
        // تنظیم موقت سطح لاگین به سطح یک
        await commit('setLoginLevel', 1);
        // دریافت مقدار کد ملی کاربر در حال لاگین
        checkAcceptCode.nationalID = state.LoginNationalID;
        console.log(checkAcceptCode);
        return await Vue.http.post('Login/LoginPart2_CheckAcceptCode', checkAcceptCode).then(async response => {
            console.log(response);
            if (response.body.result === 'OK') {
                // مرحله دوم ورود با موفقیت انجام شد
                await commit('setUserData', response.body.result_value);
                await dispatch('setAuthCookie', response);
                newRoutes.push("AdminPanel");
                return 'AdminPanel';
            } else {
                await commit('setLoginError', response.body.text);
                if (response.body.blockStatus == true) {
                    newRoutes.push("BlockIP");
                    return 'BlockIP';
                } else {
                    if (response.body.showStatus === "Login") {
                        newRoutes.push("Login");
                        return 'Login';
                    } else {
                        // خطا در ورود مرحله دوم
                        // نمایش کپچا و تلاش مجدد
                        await commit('setLoginLevel', 2);
                        await commit('setCaptchaIsRequired', true);
                        return "Captcha";
                    }
                }
            };
        }, async error => {
            await commit('setLoginError', 'در اتصال به سرور خطایی رخ داده است !');
            dispatch('notify', {
                notText: 'بروز خطای ناشناخته !!\nلطفا علت بروز خطا را بررسی نمایید .',
                timeOut: 2500,
            });
            console.log('// error ... //');
            console.log(error);
            if (error.body.blockStatus == true) {
                newRoutes.push("BlockIP");
                return 'BlockIP';
            } else {
                if (error.body.showStatus === "Login") {
                    newRoutes.push("Login");
                    return 'Login';
                } else {
                    // خطا در ورود مرحله دوم
                    // نمایش کپچا و تلاش مجدد
                    await commit('setLoginLevel', 2);
                    return "Captcha";
                }
            }
        }).catch(async err => {
            await commit('setLoginError', 'در اتصال به سرور خطایی رخ داده است !');
            dispatch('notify', {
                notText: 'بروز خطای ناشناخته !!\nلطفا علت بروز خطا را بررسی نمایید .',
                timeOut: 2500,
            });
            console.log('// error ... //');
            console.log(err);
            return '';
        });
    },

    // تابع بررسی توکن
    async CheckToken({ commit, dispatch, state }) {
        var token = await Vue.cookie.get('Paresh_Auth_Token');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        return (token != null ?
            await Vue.http.get('Login/CheckToken').then(async response => {
                if (response.body.result === 'OK') {
                    // await dispatch('setAuthCookie', response);
                    // //await commit('setCheckUserLogin', true);
                    // دریافت و ذخیره اطلاعات کاربر پس از بررسی توکن
                    // console.log('setUserData ...', response.body.result_value);
                    await commit('setUserData', response.body.result_value);
                    return true;
                } else {
                    return false;
                };
            }, async error => {
                console.log('// async error ... //');
                console.log(error);

                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);

                return false;
            }).catch(err => {
                console.log('// catch error ... //');
                console.log(err);
                return false;
            }) :
            false
        );
    },

    // تابع دریافت تصویر کپچا
    async GetCaptchaImage({ commit, dispatch, state }) {
        return await Vue.http.get('Login/generateCaptcha').then(async response => {
            if (response.body.result === 'OK') {
                // console.log(response.body.result_value.CaptchaHash);
                await commit('setCaptchaHash', response.body.result_value.CaptchaHash);
                return 'data:image/png;base64, ' + response.body.result_value.CaptchaImage.FileContents.toString();
            } else {
                return null;
            };
        }, async error => {
            console.log('// error ... //');
            console.log(error);
            return null;
        }).catch(err => {
            console.log('// error ... //');
            console.log(err);
            return null;
        });
    },

    // تابع بررسی مسدود شدن آی پی در سرور
    async checkBlockIP({ commit, dispatch, state }) {
        return await Vue.http.get('Login/checkBlockIP').then(async response => {
            if (response.body.result === 'OK') {
                // ارسال مقدار دریافتی از سرور
                return response.body.result_value.BlockIP;
            } else {
                // ارسال مقدار پیش فرض - مسدود نشده است
                return false;
            };
        }, async error => {
            console.log('// error ... //');
            console.log(error);
            // ارسال مقدار پیش فرض - مسدود نشده است
            return false;
        }).catch(err => {
            console.log('// error ... //');
            console.log(err);
            // ارسال مقدار پیش فرض - مسدود نشده است
            return false;
        });
    },

    // تابع دریافت مدت انتظار مسدود شدن آی پی از سرور
    async getBlockIPTime({ commit, dispatch, state }) {
        return await Vue.http.get('Login/getBlockIPTime').then(async response => {
            if (response.body.result === 'OK') {
                // ارسال مقدار دریافتی از سرور - به ثانیه
                return response.body.result_value.BlockIPTime;
            } else {
                // ارسال مقدار پیش فرض - 5 دقیقه
                return 300;
            };
        }, async error => {
            console.log('// error ... //');
            console.log(error);
            // ارسال مقدار پیش فرض - 5 دقیقه
            return 300;
        }).catch(err => {
            console.log('// error ... //');
            console.log(err);
            // ارسال مقدار پیش فرض - 5 دقیقه
            return 300;
        });
    },

    // تابع ارسال پیامک بازیابی رمز ورود
    async sendSMSRecoveryPassword({ commit, dispatch, state }, { nationalID }) {
        return await Vue.http.post('Login/sendSMSRecoveryPassword?nationalID=' + nationalID.toString()).then(async response => {
            dispatch('notify', {
                notText: response.body.text,
                timeOut: 3500,
            });
            if (response.body.result === 'OK') {
                // عمل ارسال پیامک با موفقیت انجام شد
                return "true";
            } else {
                // ارسال مقدار پیش فرض ناموفق
                return response.body.text;
            };
        }, async error => {
            dispatch('errorHandler', error);
            // آیا کاربر به صفحه مسدود سازی آی پی منتقل شود؟
            if (error.body.blockStatus == true) {
                newRoutes.push("BlockIP");
            }
            // ارسال مقدار پیش فرض ناموفق
            return error.body.text;
        }).catch(err => {
            dispatch('errorHandler', err);
            // ارسال مقدار پیش فرض ناموفق
            return err.body.text;
        });
    },

    // تابع بازیابی رمز ورود از طریق کد بازیابی پیامک شده
    async RecoveryPasswordBySMS({ commit, dispatch, state }, { nationalID, recoveryCode }) {
        return await Vue.http.post('Login/RecoveryPasswordBySMS?nationalID=' + nationalID.toString() + '&recoveryCode=' + recoveryCode).then(async response => {
            dispatch('notify', {
                notText: response.body.text,
                timeOut: 4500,
            });
            if (response.body.result === 'OK') {
                // عمل بازیابی رمز ورود با موفقیت انجام شد
                return "true";
            } else {
                // ارسال مقدار پیش فرض ناموفق
                return response.body.text;
            };
        }, async error => {
            dispatch('errorHandler', error);
            // آیا کاربر به صفحه مسدود سازی آی پی منتقل شود؟
            if (error.body.blockStatus == true) {
                newRoutes.push("BlockIP");
            }
            // ارسال مقدار پیش فرض ناموفق
            return error.body.text;
        }).catch(err => {
            dispatch('errorHandler', err);
            // ارسال مقدار پیش فرض ناموفق
            return err.body.text;
        });
    },

    // تابع ارسال پیامک رمز یکبار مصرف جهت ورود با تلفن همراه
    async sendSMSForLoginByMobile({ commit, dispatch, state }, { mobilNumber }) {
        return await Vue.http.post('Login/sendSMSForLoginByMobile?mobilNumber=' + mobilNumber.toString()).then(async response => {
            dispatch('notify', {
                notText: response.body.text,
                timeOut: 3500,
            });
            if (response.body.result === 'OK') {
                // عمل ارسال پیامک با موفقیت انجام شد
                return "true";
            } else {
                // ارسال مقدار پیش فرض ناموفق
                return response.body.text;
            };
        }, async error => {
            dispatch('errorHandler', error);
            // ارسال مقدار پیش فرض ناموفق
            return error.body.text;
        }).catch(err => {
            dispatch('errorHandler', err);
            // ارسال مقدار پیش فرض ناموفق
            return err.body.text;
        });
    },

    // تابع ورود با رمز یکبار مصرف پیامک شده
    async LoginBySMSPassword({ commit, dispatch, state }, { mobilNumber, recoveryCode }) {
        return await Vue.http.post('Login/LoginBySMSPassword?mobilNumber=' + mobilNumber.toString() + '&recoveryCode=' + recoveryCode).then(async response => {
            dispatch('notify', {
                notText: response.body.text,
                timeOut: 4500,
            });
            if (response.body.result === 'OK') {
                // عمل ورود به میزکار با موفقیت انجام شد
                await dispatch('setAuthCookie', response);
                await commit('setUserData', response.body.result_value);
                return "true";
            } else {
                // ارسال مقدار پیش فرض ناموفق
                if (response.body.blockStatus == true) {
                    newRoutes.push("BlockIP");
                }
                return response.body.text;
            };
        }, async error => {
            if (error.body.blockStatus == true) {
                newRoutes.push("BlockIP");
            }
            dispatch('errorHandler', error);
            // ارسال مقدار پیش فرض ناموفق
            return error.body.text;
        }).catch(err => {
            dispatch('errorHandler', err);
            // ارسال مقدار پیش فرض ناموفق
            return err.body.text;
        });
    },

    // تابع ساخت کوکی و نگهداری توکن لاگین
    async setAuthCookie({ commit, dispatch, state }, response) {
        try {
            console.log('Set Cookie ...', response);
            await Vue.cookie.set(
                'Paresh_Auth_Token', // نام کوکی
                response.body.result_value.token, // مقدار کوکی
                {
                    // زمان انقضاء کوکی
                    expires: response.body.result_value.expireTime,
                    // از الزامات افتا
                    // فقط در صورتی فعال گردد که ssl روی سرور فعال باشد
                    // در غیر اینصورت مانع ایجاد کوکی روی مرورگر می شود
                    // secure: true
                }
            )
        } catch (error) {
            console.log('Error Set Cookie ...', error);
        }
    },

    // تابع حذف کوکی نگهداری توکن لاگین
    async removeAutuCookie({ commit, dispatch, state, getters }, { token }) {
        // تابع حذف کار نکرد 
        //await Vue.cookie.remove('Paresh_Auth_Token');

        // ولی مقدار دهی با خالی باعث حذف کوکی می شود
        await Vue.cookie.set(
            'Paresh_Auth_Token', // نام کوکی
            '', // مقدار کوکی
            0 // زمان انقضاء کوکی
        )

        // ذخیره سابقه فعالیت در سرور
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('Login/Logout').then(async response => { });
    },

    // تابع ویرایش اطلاعات کاربر
    async EditUserProfile({ commit, dispatch, state, getters }, { UserProfileData, token }) {
        // console.log('ویرایش اطلاعات کاربر در سرور');
        // console.log(UserProfileData);
        // متغییر بازگشت مقادیر
        let check = { Status: false };

        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('Login/EditUserProfile', UserProfileData)
            .then(response => {
                if (response.body.result === "OK") {
                    check = { Status: true, NUserCode: response.body.result_value.NUserCode, TimeStampLogin: response.body.result_value.TimeStampLogin };
                    dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                } else {
                    check = { Status: false, errorText: response.body.text }
                    dispatch('notify', { notText: response.body.text, timeOut: 5000 });
                }
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
                check = { Status: false };
            });
        return check;
    },

    // تابع ثبت کاربر جدید
    async AddNewUserToServer({ commit, dispatch, state, getters }, { UserProfileData, token }) {
        // console.log('ویرایش اطلاعات کاربر در سرور');
        // console.log(UserProfileData);
        // متغییر بازگشت مقادیر
        let check = { Status: false };

        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('Login/AddNewUser', UserProfileData)
            .then(response => {
                if (response.body.result === "OK") {
                    check = { Status: true, NUserCode: response.body.result_value.NUserCode };
                    dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                } else {
                    dispatch('notify', { notText: response.body.text, timeOut: 5000 });
                }
            }, error => {
                console.log('// error ... //');
                console.log(response.body.text);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
                check = { Status: false };
            });
        return check;
    },

    // دریافت اطلاعات کاربر از سرور با کد کاربری
    async getUserProfileDataFromServer({ commit, dispatch, state, getters }, { NUserCode, token }) {
        // console.log('// getUserProfileDataFromServer اطلاعات پروفایل کاربر //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        return await Vue.http.get('Login/getUserProfileData?NUserCode=' + NUserCode).then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                return response.body.result_value;
            } else {
                return null;
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
            return null;
        });
    },

    // دریافت لیست سطوح دسترسی کاربر از سرور با کد کاربری
    async getResourceAccessUserFromServer({ commit, dispatch, state, getters }, { token }) {
        // console.log('// getResourceAccessUserFromServer اطلاعات سطوح دسترسی کاربر //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        return await Vue.http.get('Login/getResourceAccessUser').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                return response.body.result_value;
            } else {
                return null;
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
            return null;
        });
    },

    // ذخیره لیست سطوح دسترسی کاربر در سرور
    async SaveTbResourceAccessToServer({ commit, dispatch, state, getters }, { ResourceAccess, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('Login/SaveTbResourceAccess', ResourceAccess)
            .then(response => {
                // if (response.body.result === "OK") {}
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // حذف کاربر از سرور با کد کاربری
    async CallDeleteUserFromServer({ commit, dispatch, state }, { NUserCode, token }) {
        let check = false;
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('Login/DeleteUser?NUserCode=' + NUserCode).then(response => {
            if (response.body.result === "OK") {
                // حذف کاربر از متغییر محلی لیست کاربران
                commit('DeleteUserToLocalList', { NUserCode: NUserCode });
                // اعلام حذف موفق
                check = true;
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 4000 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
            check = false;
        });
        return check;
    },

    // تغییر وضعیت فعالیت کاربر در سرور با کد کاربری
    async ChangeNStateUserFromServer({ commit, dispatch, state }, { NUserCode, ActiveStatus, token }) {
        let check = false;
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('Login/ChangeNStateUser?NUserCode=' + NUserCode + '&ActiveStatus=' + ActiveStatus).then(response => {
            if (response.body.result === "OK") {
                // تغییر وضعیت فعالیت کاربر در متغییر محلی لیست کاربران
                commit('ChangeNStateUserToLocalList', { NUserCode: NUserCode, ActiveState: ActiveStatus });
                // اعلام تغییر وضعیت موفق
                check = true;
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            } else {
                // اعلام عدم تغییر وضعیت به علت خطا در سرور
                check = false;
                dispatch('notify', { notText: response.body.text, timeOut: 4000 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
            check = false;
        });
        return check;
    },

}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/Store/Modules/Login.js